<agpr-dialog-container
    [id]="id"
    [heading]="heading"
    (close)="cancel()"
>
    <div
        [agprLoading]="showLoading"
        class="agpr-saveNewResourceDialog-content"
        [style.width]="width + 'px'"
    >
        <agpr-text-input
            [id]="`${id}_name`"
            [initialFocus]="true"
            [maxLength]="maxLength"
            [placeholder]="placeholder"
            [(ngModel)]="name"
            (ngModelChange)="clearErrors()"
            [label]="description"
            [required]="true"
            [ariaInvalid]="errors.length > 0"
            [ariaDescribedBy]="`${id}_errorMessages`"
        ></agpr-text-input>
        <ul [id]="`${id}_errorMessages`">
            <li  *ngFor="let error of errors">
                <agpr-form-message>
                    {{ error | localize }}
                </agpr-form-message>
            </li>
        </ul>
        <agpr-checkbox
            [id]="`${id}_addToGroup`"
            [(ngModel)]="addToGroup"
            [binary]="true"
            label="Common.dialog.newResource.addToGroup.label"
            (onChange)="onAddToGroupChange()"
        ></agpr-checkbox>
        <div class="agpr-saveNewResourceDialog-groupSelection">
            <agpr-autocomplete
                [id]="`${id}_groupSelector`"
                [dropdown]="true"
                placeholder="Common.dialog.newResource.group.placeholder"
                labelField="name"
                [suggestions]="groupOptions"
                [(ngModel)]="selectedGroup"
                [clearOnBlur]="false"
                [customOptions]="autocompleteCustomOptions"
                [disabled]="!addToGroup"
            >
            </agpr-autocomplete>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="`${id}_cancel`"
            (click)="cancel()"
            [label]="cancelLabel"
            [disabled]="showLoading"
            [style]="buttonStyle.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        @if (!name || showLoading || !isValid) {
            <span
                [id]="`${id}_okButton_disabledTooltip`"
                class="u-srOnly"
            >
                {{ disabledButtonTooltip | localize}}
            </span>
        }
        <agpr-button
            [id]="`${id}_ok`"
            (click)="ok()"
            [label]="okLabel"
            [ariaLabel]="okLabel"
            [disabled]="!name || showLoading || !isValid"
            [style]="buttonStyle.primary"
            [tooltip]="(!name || showLoading || !isValid) ? disabledButtonTooltip : ''"
            [ariaDescribedBy]="'saveNewResource_okButton_disabledTooltip'"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
